import script from "./CreateProjectInviteEmail.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateProjectInviteEmail.vue?vue&type=script&setup=true&lang=js"

import "./CreateProjectInviteEmail.vue?vue&type=style&index=0&id=13878cc8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13878cc8"]])

export default __exports__